import React from 'react';
import PropTypes from "prop-types";
import { TableCell, TableHead, TableRow, TableSortLabel, Checkbox } from '@material-ui/core';

export const TableHeadBajas = (props) => {

  const {
    classes,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const headCells = [
    {
      id: "apellido_nombre",
      numeric: false,
      disablePadding: true,
      label: "Apellido y Nombre",
    },
    { id: "expand" },
    {
      id: "fecha_vigencia",
      numeric: false,
      disablePadding: false,
      label: "Fecha Vigencia",
    },
    {
      id: "fecha_fin_cobertura",
      numeric: false,
      disablePadding: false,
      label: "Fec. fin Cobertura",
    },
    { 
      id: "cuil", 
      numeric: true, 
      disablePadding: false, 
      label: "CUIL" 
    },
    { 
      id: "denominacion", 
      numeric: false, 
      disablePadding: false, 
      label: "Empresa" 
    },
    { 
      id: "cuit", 
      numeric: true, 
      disablePadding: false, 
      label: "CUIT" 
    },
    { 
      id: "descripcion_afiliacion", 
      numeric: false, 
      disablePadding: false, 
      label: "Tipo de Afiliación" 
    },
    { 
      id: "judicializado", 
      numeric: false, 
      disablePadding: false, 
      label: "Judicializado" 
    },
    { 
      id: "moratoria", 
      numeric: false, 
      disablePadding: false, 
      label: "Moratoria" 
    },
    { 
      id: "incapacitado", 
      numeric: false, 
      disablePadding: false, 
      label: "Discapacidad" 
    }
  ];

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ "aria-label": "select all desserts" }}
          />
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={"left"}  /* {headCell.numeric ? "right" : "left"} */
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
  
TableHeadBajas.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};